export default __webpack_public_path__ + "static/media/white-donate.05ea2bdd.png";